import React from 'react';
import { CSSTransition } from 'react-transition-group';
import './PageFade.scss';

const PageFade = props => (
  <CSSTransition {...props} classNames="fade-translate" timeout={1000} mountOnEnter unmountOnExit />
);

export default PageFade;



// WEBPACK FOOTER //
// ./src/components/enviroments/PageFade/PageFade.jsx